import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f63885a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-musical" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Add Musical", -1))
const _hoisted_3 = { class: "p-fluid add-musical__panel" }
const _hoisted_4 = { class: "p-field add-musical__row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Musical Name", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "p-field add-musical__row add-musical__poster" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "p-field add-musical__row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rating" }, "Rating", -1))
const _hoisted_11 = { class: "p-field add-movie__row" }
const _hoisted_12 = { class: "p-field add-musical__row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "year" }, "Date Seen", -1))
const _hoisted_14 = { class: "p-field add-musical__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Knob = _resolveComponent("Knob")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_AutoComplete, {
          id: "name",
          modelValue: _ctx.selectedMusical,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMusical) = $event)),
          suggestions: _ctx.suggestions,
          onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.musicalSearch($event))),
          onItemSelect: _ctx.musicalSelected,
          onClear: _ctx.musicalCleared,
          field: "title",
          class: _normalizeClass(["add-musical__field", _ctx.invalid ? 'p-invalid' : '']),
          forceSelection: "",
          dropdownMode: "current"
        }, {
          item: _withCtx((slotProps) => [
            _createElementVNode("div", null, _toDisplayString(slotProps.item.title), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "suggestions", "onItemSelect", "onClear", "class"])
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "p-field add-musical__row",
        innerHTML: _ctx.selectedMusical?.description
      }, null, 8, _hoisted_6), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: _ctx.poster?.source,
          class: "add-musical__image"
        }, null, 8, _hoisted_8)
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_Knob, {
          modelValue: _ctx.rating,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rating) = $event)),
          id: "rating",
          size: 150,
          class: "add-musical__rating"
        }, null, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createVNode(_component_ToggleButton, {
          modelValue: _ctx.flagged,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.flagged) = $event)),
          onLabel: "Flagged",
          offLabel: "Unflagged"
        }, null, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_Calendar, {
          id: "date",
          modelValue: _ctx.selectedDate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
          showIcon: false,
          showTime: false,
          selectionMode: "single",
          maxDate: new Date()
        }, null, 8, ["modelValue", "maxDate"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_14, [
        _createVNode(_component_Button, {
          label: _ctx.saving ? 'Saving' : 'Save',
          onClick: _ctx.save,
          disabled: _ctx.saving
        }, null, 8, ["label", "onClick", "disabled"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ])
    ])
  ]))
}